export const rowsPerPageOptions = [10, 25, 50, 100, 250, 500];
export const rowsPerPageOptionsExtraLong = [...rowsPerPageOptions, 10000];
export const defaultRowsPerPage = 500;
export const defaultRowsPerPageExtraLong = 10000;
